export default {
    saleitemno: '項目No',
    saleitemname: '項目名称',
    memo: 'メモ'
};
